var _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg247Support(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 187,
    viewBox: "0 0 237 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 236.333,
    height: 187,
    rx: 16,
    fill: "#EFEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6667,
    y: 24,
    width: 188.333,
    height: 139,
    rx: 16.3778,
    fill: "#DED6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.584 114.551C160.579 126.633 152.09 136.731 140.751 139.209L138.066 131.155C143.133 130.328 147.439 127.239 149.915 122.958H139.542C134.893 122.958 131.125 119.19 131.125 114.542V97.7084C131.125 93.0599 134.893 89.2917 139.542 89.2917H151.906C149.836 72.6844 135.669 59.8334 118.5 59.8334C101.332 59.8334 87.165 72.6844 85.0941 89.2917H97.4587C102.107 89.2917 105.875 93.0599 105.875 97.7084V114.542C105.875 119.19 102.107 122.958 97.4587 122.958H84.8337C80.1853 122.958 76.417 119.19 76.417 114.542V93.5001C76.417 70.2581 95.2583 51.4167 118.5 51.4167C141.742 51.4167 160.584 70.2581 160.584 93.5001V97.7029V97.7084V114.542V114.551Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.584 114.551C160.579 126.633 152.09 136.731 140.751 139.209L138.066 131.155C143.133 130.328 147.439 127.239 149.915 122.958H139.542C134.893 122.958 131.125 119.19 131.125 114.542V97.7084C131.125 93.0599 134.893 89.2917 139.542 89.2917H151.906C149.836 72.6844 135.669 59.8334 118.5 59.8334C101.332 59.8334 87.165 72.6844 85.0941 89.2917H97.4587C102.107 89.2917 105.875 93.0599 105.875 97.7084V114.542C105.875 119.19 102.107 122.958 97.4587 122.958H84.8337C80.1853 122.958 76.417 119.19 76.417 114.542V93.5001C76.417 70.2581 95.2583 51.4167 118.5 51.4167C141.742 51.4167 160.584 70.2581 160.584 93.5001V97.7029V97.7084V114.542V114.551Z",
    fill: "url(#paint0_linear_465_3713)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_3713",
    x1: 118.5,
    y1: 51.4167,
    x2: 118.5,
    y2: 139.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg247Support);
export default __webpack_public_path__ + "static/media/247-support.0ff8610f4fc83510028b6b0b021ef373.svg";
export { ForwardRef as ReactComponent };